export function validateUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    return (
      parsed.protocol === "http:" || parsed.protocol === "https:" || parsed.hostname === "localhost"
    );
  } catch {
    return false;
  }
}
